import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

type mapStateTypes = {
  mapViewReady: boolean;
  mapLayersUpdating: boolean;
  countriesSurveySubLayers: any;
  selectedSurveySubLayers: [];
};

const mapInitialState: mapStateTypes = {
  mapViewReady: false,
  mapLayersUpdating: true,
  countriesSurveySubLayers: {},
  selectedSurveySubLayers: [],
};

export const mapSlice = createSlice({
  name: 'mapSlice',
  initialState: mapInitialState,
  reducers: {
    setMapViewReady: (state, action: PayloadAction<boolean>) => {
      state.mapViewReady = action.payload;
    },
    setMapLayersUpdating: (state, action: PayloadAction<boolean>) => {
      state.mapLayersUpdating = action.payload;
    },
    setCountriesSurveySubLayers: (state, action: PayloadAction<any>) => {
      state.countriesSurveySubLayers = action.payload;
    },
    setSelectedSurveySubLayers: (state, action: PayloadAction<[]>) => {
      state.selectedSurveySubLayers = action.payload;
    },
  },
});

export const { setMapViewReady, setMapLayersUpdating, setCountriesSurveySubLayers, setSelectedSurveySubLayers } =
  mapSlice.actions;

export const $mapViewReady = (state: RootState) => state.mapSlice.mapViewReady;
export const $mapLayersUpdating = (state: RootState) => state.mapSlice.mapLayersUpdating;
export const $countriesSurveySubLayers = (state: RootState) => state.mapSlice.countriesSurveySubLayers;
export const $selectedSurveySubLayers = (state: RootState) => state.mapSlice.selectedSurveySubLayers;

export default mapSlice.reducer;
